module.exports = __webpack_public_path__ + "static/anyesh_dev-acd3f8640e0f78ca239df6aaab4cebb8.svg";